export const minLower = (value) => {
  return value + " lowercase character" + (value > 1 ? "s" : "");
};

export const minUpper = (value) => {
  return value + " uppercase character" + (value > 1 ? "s" : "");
};

export const minNumbers = (value) => {
  return value + " number" + (value > 1 ? "s" : "");
};

export const minSpecial = (value) => {
  return value + " special character" + (value > 1 ? "s" : "");
};

export const betweenMinAndMax = (min, max) => {
  return `Password must be between ${min} and ${max} characters.`;
};
